// test2647
(2647 && 0);
